export default {fields:{id:{},bioentityAliasInfos:{fieldTranslator:'RegistryItem:bioentityAliasInfos'}}}